var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-item__delete",attrs:{"title":"Удалить из корзины"},on:{"click":function($event){return _vm.debounce(_vm.delItem)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }